import Swiper from 'swiper/dist/js/swiper.min.js';

jQuery(document).ready(function ($) {
  if (!$('.b-gallery').length) {
    return;
  }



  let galleryThumbs;
  function createNew() {
    galleryThumbs = new Swiper('.b-gallery__items', {
      slidesPerView: 4.15,
      spaceBetween: 20,
      navigation: {
        prevEl: '.b-gallery-prev-button',
        nextEl: '.b-gallery-next-button',
      },
      breakpoints: {
        420: {
          slidesPerView: 1.15,
          centeredSlides: true,
          centeredSlidesBounds: true,
        },
        767: {
          slidesPerView: 2.15,
        },
        1200: {
          slidesPerView: 3.15,
        },
      },
    });
  }

  createNew();

  function destroyAll() {
    if (galleryThumbs) {
      $('.b-gallery__items .swiper-wrapper').addClass('invisible');
      galleryThumbs.destroy(true, true);

      setTimeout(() => {
        $('.b-gallery__items .swiper-wrapper').masonry({
          itemSelector: '.b-gallery__items-image',
          gutter: 20,
          stagger: 150,
          horizontalOrder: true,
          percentPosition: true,
        }).on('layoutComplete', function () {
          masonryAlignLastRow();
        });

        let delay = 150;
        $('.b-gallery__items-image').each((index, el) => {
          $(el).css({
            // 'opacity': '1',
            'transition-delay': delay + 'ms',
            'transition-property': 'opacity',
          });

          delay += 150;
        });

        masonryAlignLastRow();

        $('.b-gallery__items .swiper-wrapper').removeClass('invisible');
      }, 500);
    }
  }

  function masonryAlignLastRow() {
    $('.b-gallery__items-image-img').css('height', '');

    let masonry_items = $('.b-gallery__items-image'),
      rowHeights = Array.from(masonry_items).map(item => item.getBoundingClientRect().bottom),
      maxHeight = Math.max(...rowHeights),
      windowWidth = $(window).width(),
      itemsInRow = windowWidth > 1199 ? 4 : (windowWidth > 767 ? 3 : (windowWidth > 420 ? 2 : 1)),
      threshold = masonry_items.length - itemsInRow;

    masonry_items.each(function (index) {
      if (index < threshold) return true;

      let itemBottom = $(this).get(0).getBoundingClientRect().bottom;
      if (itemBottom < maxHeight) {
        let image = $(this).find('.b-gallery__items-image-img'),
          delta = maxHeight - itemBottom;

        image.css('height', image.height() + delta + 'px');
      }
    });
  }

  $('.b-gallery__items-nav .destroy').on('click', event => {
    event.preventDefault();
    destroyAll();

    $('.b-gallery__items-nav .destroy, .swiper-button-prev, .swiper-button-next').hide();
    $('.b-gallery__items-nav .createnew').show();
  });

  $('.b-gallery__items-nav .createnew').on('click', event => {
    event.preventDefault();
    $('.b-gallery__items .swiper-wrapper').masonry('destroy');

    $('.b-gallery__items .swiper-wrapper').animate({
      opacity: 0,
    }, 300, 'swing', () => {
      setTimeout(() => {
        // $('.b-gallery__items-image').removeAttr('style');
        $('.b-gallery__items-image-img').css('height', '');

        createNew();

        $('.b-gallery__items .swiper-wrapper').animate({
          opacity: 1,
        }, 300, 'swing');

        $('.b-gallery__items-nav .destroy, .swiper-button-prev, .swiper-button-next').show();
        $('.b-gallery__items-nav .createnew').hide();
      }, 500);
    });
  });
});



// WEBPACK FOOTER //
// ./scripts/blocks/gallery.js